import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { DomSanitizer } from "@angular/platform-browser";
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';
import { ICONS } from '../../../../_helpers/icons.constants';

@Component({
    selector: 'app-text-tooltip-renderer',
    templateUrl: './text-tooltip-renderer.component.html',
    standalone: true,
    imports: [CommonModule, TranslateModule, FormsModule, NgbPopoverModule]
})
export class TextWithTooltipRendererComponent implements ICellRendererAngularComp {
    text: string;
    toolTipText: string;
    position = "left";
    constructor(private sanitizer: DomSanitizer) { }
    public ICONS = ICONS;
    initilize(params: ICellRendererParams) {
        let data = params.getValue();

        if (data) {
            this.text = data.text;
            this.toolTipText = data.tooltip;
            this.position = params.colDef?.cellRendererParams?.tooltipPosition;
        }
    }

    agInit(params: any): void {
        this.initilize(params);
    }

    refresh(params: any): boolean {
        this.initilize(params);
        return true;
    }

    sanitizerHtml(element) {
        return this.sanitizer.bypassSecurityTrustHtml(element);
    }

}
